const configStreaming = {
  streaming: {
    listLayout: 'StreamingListLayout',
    filterLayout: 'StreamingFilterLayout',
    paginationLayout: 'PaginationDefaultLayout',
    getFunc: 'getStreaming',
    listApiParamSet: {
      ip: 1,
    },
    deleteFunc: 'deleteStreaming',
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {
      '-100': '필수값이 없습니다',
      '-403': '권한이 없습니다.',
      '-404': '객체가 없습니다.',
      '-365': "레귤러 컨텐츠가 존재합니다",
    },
    keyName: 's_idx'
  },
  streamingStudent: {
    listLayout: 'StreamingListStudentLayout',
    filterLayout: 'StreamingFilterStudentLayout',
    paginationLayout: 'PaginationRefundLayout',
    getFunc: 'getStreamingStudent',
    listApiParamSet: {
      ip: 1,
    },
    deleteFunc: 'refundStreaming',
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {
    },
    keyName: 'mb_no',
  },
  create: {
    writeLayouts: ['StreamingWriteDefaultLayout'],
    writeFunc: 'createStreaming',
    writeApiParamSet: {
      c_idx: '1',
    },
    validityData: {
      title: 'title',
      liveTime: 'liveTime',
      liveFiles: 'liveFiles',
      listFiles: 'listFiles'
    },
    parsingData: {
      title: 's_title',
      liveTimesd: 's_live_start',
      liveTimeed: 's_live_end',
    },
    directUrl: '/streaming',
    directType: 'back',
    writeSuccessType: 1,
    writeFailTypes: {
      '-100': "필수값 없음.",
      '-257': "등록된 라이브 제목입니다.",
      '-403': "권한이 없습니다.",
    },
  },
  detail: {
    writeLayouts: ['StreamingWriteDefaultLayout'],
    getFunc: 'getStreaming',
    detailApiParamsSet: {
      ip: 1,
    },
    getDetailParamsKey: 'id',
    writeFunc: 'updateStreaming',
    writeApiParamSet: {
      // c_idx: '1',
    },
    validityData: {
      title: 'title',
      liveTime: 'liveTime'
    },
    parsingData: {
      title: 's_title',
      liveTimesd: 's_live_start',
      liveTimeed: 's_live_end',
      liveOn: 's_status',
    },
    directUrl: '/streaming',
    directType: 'back',
    writeSuccessType: 1,
    writeFailTypes: {
      '-100': "필수값 없음.",
      '-257': "등록된 라이브 제목입니다.",
      '-258': "한번에 하나의 카메라만 ON 가능합니다.",
      '-404': "객체가 없습니다.",
    },
    keyName: 's_idx',
    deleteFunc: 'deleteStreaming',
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {
      '-100': '필수값이 없습니다',
      '-403': '권한이 없습니다.',
      '-404': '객체가 없습니다.',
      '-365': "레귤러 컨텐츠가 존재합니다",
    },
  },
  liveKlassCreate: {
    writeLayouts: ['StreamingWriteLiveKlassLayout'],
    writeFunc: 'createStreaming',
    writeApiParamSet: {
      s_status: '4',
    },
    validityData: {
      title: 'title',
      koin: 'koin',
      url: 'url',
      liveStartTime: 'liveStartTime',
    },
    parsingData: {
      title: 's_title',
      koin: 's_price',
      url: 's_url',
      liveStartTime: 's_live_start',
    },
    directUrl: '/liveklass',
    directType: 'back',
    writeSuccessType: 1,
    writeFailTypes: {
      '-100': "필수값 없음.",
      '-387': '방송 시작 시간은 현재 시간의 20분 후부터 가능합니다.',
      '-388': '동일한 시간대의 스트리밍이 존재합니다.',
      '-389': '시작시간 기준으로 시작전 20분부터<br> 모든 정보 수정 불가능합니다.',
      '-403': '해당권한이 업습니다.',
      '-404': '객체 없음',
    },
  },
  liveKlassDetail: {
    writeLayouts: ['StreamingWriteLiveKlassLayout'],
    getFunc: 'getStreaming',
    detailApiParamsSet: {
      ip: 1,
    },
    getDetailParamsKey: 'id',
    writeFunc: 'updateStreaming',
    writeApiParamSet: {
      // c_idx: '1',
    },
    validityData: {
      title: 'title',
      koin: 'koin',
      url: 'url',
      liveStartTime: 'liveStartTime',
    },
    parsingData: {
      title: 's_title',
      koin: 's_price',
      url: 's_url',
      liveStartTime: 's_live_start',
      display:'s_is_display' 
    },
    directUrl: '/liveklass',
    directType: 'back',
    writeSuccessType: 1,
    writeFailTypes: {
      '-100': "필수값 없음.",
      '-387': '방송 시작 시간은 현재 시간의 20분 후부터 가능합니다.',
      '-388': '동일한 시간대의 스트리밍이 존재합니다.',
      '-389': '시작시간 기준으로 시작전 20분부터<br> 모든 정보 수정 불가능합니다.',
      '-403': '해당권한이 업습니다.',
      '-404': '객체 없음',
    },
    keyName: 's_idx',
    deleteFunc: 'deleteStreaming',
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {
      '-100': '필수값이 없습니다',
      '-104': '등록된 수강 학생이 있어 삭제가 불가합니다.<br> 환불 처리 후 삭제해주세요',
      '-403': '권한이 없습니다.',
      '-404': '객체가 없습니다.',
      '-365': "레귤러 컨텐츠가 존재합니다",
    },
  },
}

export default {
  methods: {
    returnStreamingConfig(type) {
      return configStreaming[type];
    }
  },
  filterConfig: {
    cr: { //작성일
      type: 'between',
      classname: 'filterDate'
    },
    sl: { //작성일
      type: 'between',
      classname: 'filterStreamingDate'
    },
    ti: { //제목
      type: 'query',
      classname: 'searchInput',
    },
    id: {
      type: 'match',
      classname: 'filterId'
    },
    pr: { //작성일
      type: 'between',
      classname: 'filterPaymentDate'
    },
    mid: { // 아이디
      type: 'query',
      classname: 'searchInput',
    },
    ni: { // 닉네임
      type: 'query',
      classname: 'searchInput',
    },
  }
}
